import { FC } from 'react';
import Navigation from '../navigation/Navigation.tsx';
import AboutMe from '../aboutMe/AboutMe.tsx';
import Projects from '../projects/Projects.tsx';
import Footer from '../footer/Footer.tsx';

const App: FC = () => {
    return (
        <>
            <Navigation />
            <main>
                <AboutMe />
                <Projects />
            </main>
            <Footer />
        </>
    );
}

export default App;